import {useQuery} from 'react-query';
import {getFirstRound} from '../../api/apiGame';

export const useFirstRound = () => {
    return useQuery('first-round', getFirstRound);
};
